/** Staff/superuser — to'liq ruxsat */
export const hasFullAccess = userInfo =>
  Boolean(userInfo?.is_staff || userInfo?.is_superuser);

/** L1 — qurilma asosiy sozlamalari (edit) */
export const canL1 = userInfo =>
  hasFullAccess(userInfo) || Boolean(userInfo?.access_to_settings_l1);

/** L2 — modem davr sozlamalari */
export const canL2 = userInfo =>
  hasFullAccess(userInfo) || Boolean(userInfo?.access_to_settings_l2);

/** L3 — integratsiya */
export const canL3 = userInfo =>
  hasFullAccess(userInfo) || Boolean(userInfo?.access_to_settings_l3);

/** L4 — foydalanuvchilar boshqaruvi + biriktirish */
export const canL4 = userInfo =>
  hasFullAccess(userInfo) || Boolean(userInfo?.access_to_settings_l4);

/** Settings sahifasiga kirish (L1-L4 dan biri) */
export const canEditDevice = userInfo =>
  canL1(userInfo) || canL2(userInfo) || canL3(userInfo) || canL4(userInfo);

export const canManageUsers = userInfo => canL4(userInfo);
